import axios, { AxiosResponse } from "axios";
import { getEnvVar } from "ideas.env";
import { getRequestHeaders } from "utils/getRequestHeaders";

/**
 * Updates tool version to publish the draft spec through Django backend
 * provides the version string for the new published version
 * the status is set to published by the backend
 */
export const publishToolVersion = async (
  toolVersionId: number,
  version: string,
  changelog: string | undefined,
) => {
  const headers = await getRequestHeaders();

  const res = await axios.patch<
    { status: number; version: string },
    AxiosResponse<{
      status: number;
      version: string;
      changelog: string | null;
    }>
  >(
    getEnvVar("URL_TRS_TOOL_VERSION_PUBLISH")(toolVersionId),
    { version, changelog },
    { headers },
  );

  return res.data;
};
